import { Box, CircularProgress, Typography } from '@mui/material';

import { colors } from '@/global/styles/colors';

const TransactionSubmittedToast = (): React.ReactNode => {
  return (
    <Box className='flex items-center gap-x-3'>
      <CircularProgress size={24} sx={{ color: colors.black }} />
      <Box>
        <Typography className='text-base font-semibold'>Transaction submitted</Typography>
        <Typography className='text-sm font-normal'>Waiting for confirmation</Typography>
      </Box>
    </Box>
  );
};

export default TransactionSubmittedToast;
